var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNtfy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#348878",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#56bda8",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 160.722,
    y1: 128.533,
    x2: 168.412,
    y2: 134.326,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-845.726 -630.598) scale(5.59448)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "url(#b)",
      stroke: "none",
      strokeWidth: 3.72347,
      InkscapeStroke: "none"
    },
    d: "M94.237 89.912H59.499c-2.388 0-4.342 1.844-4.342 4.098l.033 27.754-.648 3.738 9.297-2.806h30.396c2.388 0 4.342-1.845 4.342-4.099V94.01c0-2.254-1.954-4.098-4.342-4.098z",
    transform: "translate(-51.147 -81.516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#fff",
      stroke: "none",
      strokeWidth: 0.762343,
      InkscapeStroke: "none"
    },
    d: "M58.849 86.79c-3.62 0-6.72 2.848-6.72 6.47v.002l.035 30.273-.91 6.708 12.362-3.284h30.729c3.62 0 6.72-2.852 6.72-6.473V93.26c0-3.62-3.099-6.469-6.717-6.469h-.003zm0 4.566h35.499c1.272 0 2.151.927 2.151 1.903v27.227c0 .977-.88 1.924-2.154 1.903h-31.4l-6.28 1.898.065-.37-.035-30.658c0-.977.88-1.903 2.154-1.903z",
    transform: "translate(-51.147 -81.516)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "8.48274px",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000",
      stroke: "none",
      strokeWidth: 0.525121
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#fff",
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M62.57 116.77v-1.312l3.28-1.459q.159-.068.306-.102.158-.045.283-.068l.271-.022v-.09q-.136-.012-.271-.046-.125-.023-.283-.057-.147-.045-.306-.113l-3.28-1.459v-1.323l5.068 2.319v1.413z",
    transform: "matrix(2.1689 0 0 2.57844 -124.28 -268.742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#fff",
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M62.309 110.31v1.903l3.437 1.53.022.007-.022.008-3.437 1.53v1.892l.37-.17 5.221-2.39v-1.75zm.525.817 4.541 2.08v1.076l-4.541 2.078v-.732l3.12-1.389.003-.002a1.56 1.56 0 0 1 .258-.086h.006l.008-.002c.094-.027.176-.047.246-.06l.498-.041v-.574l-.24-.02a1.411 1.411 0 0 1-.231-.04l-.008-.001-.008-.002a9.077 9.077 0 0 1-.263-.053 2.781 2.781 0 0 1-.266-.097l-.004-.002-3.119-1.39z",
    transform: "matrix(2.1689 0 0 2.57844 -124.28 -268.742)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "8.48274px",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000",
      stroke: "none",
      strokeWidth: 0.525121
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#fff",
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M69.171 117.754h5.43v1.278h-5.43Z",
    transform: "matrix(2.16247 0 0 2.48294 -122.76 -261.211)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      InkscapeFontSpecification: "'JetBrains Mono, Bold'",
      fill: "#fff",
      stroke: "none",
      InkscapeStroke: "none"
    },
    d: "M68.908 117.492v1.802h5.955v-1.802zm.526.524h4.904v.754h-4.904z",
    transform: "matrix(2.16247 0 0 2.48294 -122.76 -261.211)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtfy);
export default __webpack_public_path__ + "static/media/ntfy.813163689f875c027536f701421d9b3d.svg";
export { ForwardRef as ReactComponent };